
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punemumbaipuneroundtrip() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Round Trip Taxi Services',
        heading: 'S9 Travels: Pune to Mumbai Round Trip Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable round-trip taxi services from Pune to Mumbai. Whether you are traveling for business, leisure, or exploring the vibrant city of Mumbai, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. The distance from Pune to Mumbai is approximately 150 km, and the journey takes around 3 to 4 hours by road, depending on traffic conditions. With our round-trip service, you can enjoy a stress-free, comfortable, and enjoyable ride.',

        top: 'Top Places to Explore in Mumbai with S9 Travels:',

        "topPlaces": [
            {
              "title": "Gateway of India",
              "description": "The iconic Gateway of India is one of Mumbai's most famous landmarks. Built during the British Raj, it overlooks the Arabian Sea and is a major tourist attraction. The monument is a great spot to begin your exploration of the city and offers a beautiful view of the sea."
            },
            {
              "title": "Marine Drive",
              "description": "Known as the 'Queen’s Necklace,' Marine Drive is a scenic, sweeping boulevard along the coastline of Mumbai. It’s perfect for a relaxing evening walk while enjoying the cool breeze and panoramic views of the city skyline and the sea. It’s a must-visit spot, especially for photography enthusiasts during sunset."
            },
            {
              "title": "Colaba Causeway",
              "description": "A bustling street market in Colaba, this is the place to shop for souvenirs, handicrafts, clothes, and accessories. Colaba Causeway is also home to lively cafes, restaurants, and art galleries, making it a great place to experience the local culture and shop till you drop."
            },
            {
              "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
              "description": "A UNESCO World Heritage Site, CST is an architectural marvel and one of Mumbai's busiest railway stations. Its stunning Victorian Gothic architecture is a blend of Indian and European styles. A visit to CST offers an insight into Mumbai's colonial past while also marveling at its grandeur."
            },
            {
              "title": "Elephanta Caves",
              "description": "A short boat ride from the Gateway of India takes you to Elephanta Island, home to the ancient Elephanta Caves. These rock-cut temples and sculptures dedicated to Lord Shiva are a UNESCO World Heritage Site. The peaceful island is an escape from the city bustle and provides fascinating historical insights."
            },
            {
              "title": "Bandra-Worli Sea Link",
              "description": "The Bandra-Worli Sea Link is a modern marvel that connects the suburbs of Bandra and Worli. It’s not just a transportation route but a beautiful bridge offering stunning views of the Arabian Sea and the Mumbai skyline. Drive across the bridge to experience the beauty of Mumbai from a different perspective."
            },
            {
              "title": "Babulnath Temple",
              "description": "An ancient temple dedicated to Lord Shiva, located on a hill with a peaceful ambiance and breathtaking views of the city. The temple’s spiritual atmosphere makes it a perfect stop for those seeking a moment of tranquility amidst the city’s hustle."
            },
            {
              "title": "Chor Bazaar",
              "description": "Known as Mumbai's 'Thieves Market,' Chor Bazaar is famous for antiques, vintage items, and second-hand goods. It’s a fascinating area to explore for those looking for unique finds and an authentic local shopping experience. The market has everything from old furniture to rare collectibles."
            },
            {
              "title": "Juhu Beach",
              "description": "One of Mumbai’s most popular beaches, Juhu Beach is a lively spot with vendors selling local snacks, and people enjoying the cool ocean breeze. It’s a fantastic place to relax, take a leisurely walk, or watch the sunset. The beach is also home to some luxurious hotels and restaurants where you can enjoy a fine dining experience with a view."
            },
            {
              "title": "Haji Ali Dargah",
              "description": "Situated on an islet off the coast of Worli, the Haji Ali Dargah is a mosque and tomb that draws thousands of devotees and tourists. The walk to the Dargah during low tide offers a spiritual and unique experience. The tomb is dedicated to a Muslim saint, and the serene atmosphere makes it an important place of worship."
            }
          ],

"services": [
  {
    "name": "Pune Mumbai Round Trip Cab",
    "description": "S9 Travels offers comfortable and reliable round-trip cab services for your journey between Pune and Mumbai. Whether you’re traveling for business, leisure, or any other purpose, enjoy a smooth and hassle-free ride. Book your Pune to Mumbai round-trip cab today!"
  },
  {
    "name": "Pune Mumbai Round Trip Taxi",
    "description": "Choose S9 Travels for a professional and dependable taxi service for your Pune to Mumbai round trip. Our experienced drivers and well-maintained vehicles ensure a safe, comfortable, and enjoyable journey, making your trip pleasant from start to finish."
  },
  {
    "name": "Pune to Mumbai Round Trip Service",
    "description": "S9 Travels provides a reliable and efficient round-trip service for your journey from Pune to Mumbai. With flexible timings and professional drivers, we ensure that your trip is both enjoyable and stress-free."
  },
  {
    "name": "Pune to Mumbai Round Trip Booking",
    "description": "Booking a round-trip taxi for your Pune to Mumbai journey is easy with S9 Travels. Whether you're booking online or over the phone, we offer flexible booking options tailored to your schedule. Book your round-trip today!"
  },
  {
    "name": "Pune to Mumbai Round Trip Fare",
    "description": "S9 Travels offers transparent and competitive fares for your Pune to Mumbai round trip. With no hidden charges, you can travel comfortably and confidently while enjoying the best value for your money. Contact us for an accurate fare estimate."
  },
  {
    "name": "Pune to Mumbai Round Trip Car Rental",
    "description": "Looking to rent a car for your Pune to Mumbai round trip? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that suit your travel needs and preferences."
  },
  {
    "name": "Pune to Mumbai Round Trip Taxi Service",
    "description": "Choose S9 Travels for a reliable, comfortable, and efficient round-trip taxi service from Pune to Mumbai. Our professional drivers and well-maintained vehicles ensure that your journey is hassle-free and enjoyable every time."
  }
],


"tableData": [
  ["Pune Mumbai Round Trip Cab", "Pune Mumbai Round Trip Taxi"],
  ["Pune To Mumbai Round Trip Service", "Pune To Mumbai Round Trip Booking"],
  ["Pune To Mumbai Round Trip Fare", "Pune To Mumbai Round Trip Car Rental"],
  ["Pune To Mumbai Round Trip Taxi Service", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality for your round trip from Pune to Mumbai. Whether you're traveling for business, a leisure trip, or any other purpose, our drivers ensure timely pickups and drop-offs, making your round trip seamless and stress-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We provide a variety of comfortable and spacious vehicles for your Pune to Mumbai round trip. With air conditioning, comfortable seating, and ample space for luggage, our vehicles are perfect for a relaxed and enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and well-trained, ensuring a safe and comfortable round trip. They are familiar with the best routes to avoid traffic and are committed to providing you with a smooth travel experience from Pune to Mumbai and back."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable pricing for your Pune to Mumbai round trip. We provide clear pricing upfront, with no hidden charges, and a breakdown of costs, so you know exactly what to expect for your round trip."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring that you have a safe and comfortable journey both ways."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you need an early morning departure or a late-night return, S9 Travels operates 24/7 to accommodate your schedule. Our customer service team is also available around the clock to assist with bookings or inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Mumbai round trip cab is simple with S9 Travels. You can book online via our website or mobile app, or call our customer service team for personalized assistance with your reservation."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your round trip, whether it’s for business meetings, family visits, sightseeing, or a corporate trip. Let us know your requirements, and we will tailor the journey to suit your needs."
  }
]



















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Mumbai round trip cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for assistance with your booking.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the best routes to Mumbai, ensuring a smooth and safe journey both ways.',
          },
          {
            question: 'What types of vehicles are available for Pune to Mumbai round trip travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained and designed for comfort during your round trip.',
          },
          {
            question: 'How do I pay for my Pune to Mumbai round trip cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, making the payment process easy and convenient.',
          },
          {
            question: 'Can I book a round trip from Pune to Mumbai?',
            answer: 'Yes, you can easily book a round trip. Simply provide your return details, and we’ll arrange everything to make your trip smooth and hassle-free.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as waiting time or detours, will be clearly communicated to you upfront, ensuring full transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Mumbai during my round trip?',
            answer: 'Yes, we can arrange sightseeing tours in Mumbai as part of your round trip. Explore popular attractions like Gateway of India, Marine Drive, and more, with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Mumbai round trip cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Mumbai?',
            answer: 'Yes, we offer corporate travel services for group trips, business meetings, or corporate events between Pune and Mumbai. We ensure punctual and professional service to meet your business needs.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Mumbai round trip travel?',
            answer: 'S9 Travels ensures a comfortable, reliable, and affordable round trip with professional drivers, well-maintained vehicles, and excellent customer service. We guarantee a smooth, stress-free, and enjoyable journey for your round trip from Pune to Mumbai.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a round trip from Pune to Mumbai with S9 Travels for a business meeting. The driver was professional, and the vehicle was comfortable. Everything went smoothly, and I will definitely use their service again.”',
        },
        {
          name: 'Mrs. Shalini Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family had a fantastic trip to Mumbai with S9 Travels. The round trip was well-organized, the driver was friendly, and the vehicle was clean and spacious. A great experience!”',
        },
      ];
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Mumbai Pune Round Trip",
        "description": "Book Pune to Mumbai round trip taxi services, one-way taxi, car rental, and more with S9 Travels. Choose from affordable Pune to Mumbai round trip cab booking options for a comfortable and hassle-free journey between Pune and Mumbai.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
    return (
        <div>
           <Helmet>
        <title>Pune Mumbai Pune Round Trip | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Mumbai round trip taxi services, one-way taxi, car rental, and more with S9 Travels. Get the best fares for Pune to Mumbai round trip booking and enjoy a comfortable, safe, and convenient ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      


<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punemumbaipuneroundtrip;